import { Location, LocationState } from 'history';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Button, { Theme } from '../button/Button';

import './NavigateBackButton.scss';

interface Props {
  label?: string;
  link: string | Location<LocationState>;
}

const NavigateBackButton: FC<Props> = ({ label = '', link }) => {
  const { t } = useTranslation();

  let url: string;
  if (typeof link === 'string') {
    url = link as string;
  } else if (link.search) {
    url = link.pathname + '?' + link.search;
  } else {
    url = link.pathname;
  }
  return (
    <Button className='navigate-back-button' theme={Theme.TRANSPARANT} icon='LeftArrow' link={url}>
      <p>{t(label)}</p>
    </Button>
  );
};

export default NavigateBackButton;
